export default (props, vars) =>
  `tooltip-wrapper-4-${vars?.['defaultforeach2']?.['item']?.['displayName']}`;
